<template>
<div class="home">
    <div class=" flex flex-col sticky z-10 shadow bg-white mb-12 w-full" style="top: 50px">
        <div class="mx-8 mt-4">
            <linput v-model="search" class="py-2" placeholder="Search by Gradable Title" />
        </div>
        <div />
    </div>
    <div class="px-8">
        <table v-if="filteredRecords.length > 0" class="table-auto w-full">
            <thead>
                <tr>
                    <th class="px-4 py-1">sn</th>
                    <th class="w-8/12 px-4 py-1">Gradable</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(x, index) in filteredRecords" :key="index">
                    <td class="px-4 border-b py-5 text-center">{{ index + 1 }}</td>

                    <td class="px-4 border-b py-5 text-center">{{ `${x.title}` }}</td>
                    <td class="px-4 border-b py-5 text-center"></td>
                </tr>
            </tbody>
        </table>
        <div class="text-center text-2xl font-semibold text-black" v-else>
            No Records Found!
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapMutations
} from "vuex";
export default {
    data() {
        return {
            quickSearch: "",
            list: [],
            search: ""
        };
    },
    computed: {
        filteredRecords() {
            if (this.search !== "") {
                return this.list.filter((grade) => {
                    return grade.title.toLowerCase().match(this.search.toLowerCase());
                });
            } else {
                let data = this.list.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return (
                            String(row[key])
                            .toLowerCase()
                            .indexOf(this.quickSearch.toLowerCase()) > -1 || row.title.toLowerCase.match(this.search.toLowerCase())
                        );
                    });
                });

                return data;
            }

        },
    },
    components: {
        card: () => import("@/components/tenant/reward-card"),
        lbutton: () => import("@/components/general/button"),
        linput: () => import("@/components/general/input"),
    },
    methods: {
        ...mapActions(["tenantFetchAllGradable"]),
        ...mapMutations(["updateLoader"]),
        async deleteData(e) {
            if (confirm("Are you sure you want to delete this Gradable?")) {
                let res = await this.tenantDeleteBadge({
                    id: e,
                });
                this.loadData();
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Gradable deleted successfully",
                });
                //console.log(e);
            }
        },
    },
    async mounted() {
        this.updateLoader(true);
        let res = await this.tenantFetchAllGradable();
        this.list = res.data.data.gradables;
        this.updateLoader(false);
    },
};
</script>
